<template>
  <section class="favorite-page" v-if="(buildings.length > 0 || flats.length > 0)">

    <favorite-list :type="'buildings'" :items="buildings" ></favorite-list>
    <favorite-list :type="'flats'" :items="flats" ></favorite-list>
  </section>
  <section class="favorite-page mb-4" v-else>
    В избранном пока ничего нет.
  </section>
</template>
<script>
import list from "./favoriteList"
export default {
  components:{
    'FavoriteList':list,
  },
  data() {
    return {
     buildings:[],
      flats:[],
    }
  },
  methods: {
    getList() {
      axios.get('/api/favorite/get-list')
      .then((response) => {
       this.buildings = response.data.buildings;
       console.log(response.data.favorites)
        this.flats = response.data.flats;
      })
    }
  },
  mounted() {
    this.getList();
  }
}
</script>